import {createStrokeSVG} from './TEMPLATE'

// tabler: accessible
export const Accessibility_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0',
    'M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1',
    'M11.5 7.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
